module.exports = __webpack_public_path__ + "static/media/helically_formed_side_tie.c75273d1.webp";